import { Fragment, useMemo } from "react";
import HeaderCell from "src/components/shared/EntriesGenerator/HeaderCell";
import { type ILandscapeRow } from "src/generator/LandscapeOrientation/landscape.types";
import { StyledTr } from "src/styled";

import RowCell from "../RowCell";

interface Props {
  row: ILandscapeRow;
  history?: boolean;
  // isOverlay?: boolean;
}

const LandscapeRow = ({ row }: Props) => {
  const rowSpan = useMemo(() => Object.keys(row.items).length, [row.items]);
  return (
    <Fragment>
      {Object.values(row.items).map((item, idx) => (
        <StyledTr key={`row-${idx}`}>
          {idx === 0 && (
            <HeaderCell
              col={row}
              sIndex={idx}
              rowspan={rowSpan}
              thStyling
              style={{
                width: 150,
                position: "relative",
              }}
              contentWrapperStyles={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            />
          )}
          <HeaderCell
            sIndex={idx}
            col={item as any}
            thStyling
            style={{
              width: 150,
              position: "relative",
            }}
          />
          {Object.entries(item.cols).map(([, value], i) => (
            <RowCell key={`row-c-${i}-${idx}`} col={value} index={i} />
          ))}
        </StyledTr>
      ))}
    </Fragment>
  );
};
export default LandscapeRow;
